import { useEffect } from "react";

const SurveyBot = () => {
  useEffect(() => {
    const botId = process.env.REACT_APP_DOCKCOPY_BOT_ID;

    const embedScript = document.createElement("script");

    embedScript.type = "text/javascript";
    embedScript.id = "chatbot-embed-script";
    embedScript.className = "my-chatbot-embedder";
    embedScript.setAttribute("data-botId", botId);

    document.body.appendChild(embedScript);

    const injectionScript = document.createElement("script");

    injectionScript.type = "text/javascript";
    injectionScript.async = true;
    injectionScript.src = "https://dcbot.dock.bot/js/injection.js";

    embedScript.parentNode.insertBefore(injectionScript, embedScript.nextSibling);

    return () => {
      injectionScript.remove();
      embedScript.remove();
    };
  }, []);

  return null;
};

export default SurveyBot;

// ================================================================ OLDER BOTCOPY VERSION ================================================================

// import { useEffect, useRef, useState } from "react";
// import { ValidateGuestPreferencesAPI } from "api/bot";

// const SurveyBot = () => {
//   const [loading, setLoading] = useState(true);

//   const injectedScriptRef = useRef(null);
//   const retryTimeoutRef = useRef(null);
//   const destroyedRef = useRef(false);

//   const sessionParametersRef = useRef({
//     pid: "",
//     rid: "",
//     validationSuccess: "false",
//     validationMessage: "",
//     guestName: "",
//   });

//   useEffect(() => {
//     let isMounted = true;

//     destroyedRef.current = false;

//     const urlParams = new URLSearchParams(window.location.search);

//     const pid = urlParams.get("pid");
//     const rid = urlParams.get("rid");

//     const applyCXParameters = () => {
//       const tryApply = () => {
//         if (destroyedRef.current) return;

//         if (window.Botcopy && typeof window.Botcopy.setCXParameters === "function") {
//           try {
//             window.Botcopy.setCXParameters({
//               parameters: sessionParametersRef.current,
//             });
//           } catch (error) {
//             retryTimeoutRef.current = setTimeout(tryApply, 400);
//           }

//           return;
//         }

//         retryTimeoutRef.current = setTimeout(tryApply, 400);
//       };

//       tryApply();
//     };

//     const handleBotEvents = (event) => {
//       const eventType = event?.detail?.type;

//       if (eventType === "bc-auth-required") {
//         applyCXParameters();
//       }
//     };

//     const injectChatbotScript = () => {
//       const existingEmbedScript = document.getElementById("chatbot-embed-script");

//       if (existingEmbedScript) {
//         return;
//       }

//       const embedScript = document.createElement("script");

//       embedScript.type = "text/javascript";
//       embedScript.id = "chatbot-embed-script";
//       embedScript.className = "my-chatbot-embedder";
//       embedScript.setAttribute("data-botId", "6a3cc446fe160ca8af8ebd6e");

//       document.body.appendChild(embedScript);

//       const injectionScript = document.createElement("script");

//       injectionScript.type = "text/javascript";
//       injectionScript.async = true;
//       injectionScript.src = "https://dcbot.dock.bot/js/injection.js";

//       embedScript.parentNode.insertBefore(injectionScript, embedScript.nextSibling);

//       injectedScriptRef.current = {
//         embedScript,
//         injectionScript,
//       };
//     };

//     const initializeBot = async () => {
//       try {
//         if (!pid || !rid) {
//           sessionParametersRef.current = {
//             pid: pid || "",
//             rid: rid || "",
//             validationSuccess: "false",
//             validationMessage: "Missing reservation details.",
//             guestName: "",
//           };
//         } else {
//           const response = await ValidateGuestPreferencesAPI({
//             pid,
//             rid,
//           });

//           const guest = response?.data?.data?.guest || {};

//           sessionParametersRef.current = {
//             pid,
//             rid,
//             validationSuccess: "true",
//             validationMessage: response?.data?.message || "Validation successful.",
//             guestName: guest?.name || `${guest?.firstName || ""}`.trim(),
//           };
//         }
//       } catch (error) {
//         const errorData = error?.response?.data;

//         sessionParametersRef.current = {
//           pid: pid || "",
//           rid: rid || "",
//           validationSuccess: "false",
//           validationMessage:
//             errorData?.message || "Sorry, we could not validate your reservation at this time.",
//           guestName: "",
//         };
//       } finally {
//         if (!isMounted) return;

//         window.addEventListener("botcopy-events", handleBotEvents);

//         injectChatbotScript();

//         setLoading(false);
//       }
//     };

//     initializeBot();

//     return () => {
//       isMounted = false;
//       destroyedRef.current = true;

//       window.removeEventListener("botcopy-events", handleBotEvents);

//       if (retryTimeoutRef.current) {
//         clearTimeout(retryTimeoutRef.current);
//       }

//       if (injectedScriptRef.current) {
//         injectedScriptRef.current.injectionScript?.remove();
//         injectedScriptRef.current.embedScript?.remove();
//       }

//       injectedScriptRef.current = null;
//     };
//   }, []);

//   return (
//     <div
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: "24px",
//         textAlign: "center",
//       }}
//     >
//       {loading && <h4>Loading please wait...</h4>}

//       <div id="botcopy-container" />
//     </div>
//   );
// };

// export default SurveyBot;
